module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_map_sp_3-53ca18e1f0a4374749e8f563094bb809.svg";